import React from "react";
import { Box, Flex } from "@chakra-ui/core";
import OrdersGrid from "../dashboard/OrdersGrid";
import CustomersGrid from "../dashboard/CustomersGrid";
import PayoutsGrid from "../dashboard/PayoutsGrid";

/** The core content of the dashboard rendering the actuall datas tables */

const DashboardBodyMain = ({
  currentSection,
  customers,
  transactions,
  payouts,
  refetch,
}) => {
  return (
    <>
      <Box width="100%" background="#eeedee" p={0}>
        <Flex align="center" justify="center" w="100%">
          <Box maxWidth="1280px" w="100%" h="100%">
            <Box
              background="white"
              pt="10px"
              m="auto"
              mx="10px"
              px="10px"
              mb="2rem"
              pb="1rem"
              borderBottomRightRadius="8px"
              borderBottomLeftRadius="8px"
            >
              {currentSection === "orders" && (
                <OrdersGrid {... {transactions, refetch}} />
              )}
              {currentSection === "customers" && (
                <CustomersGrid refetch={refetch} retrievedCustomers={customers} />
              )}
              {currentSection === "payouts" && (
                <PayoutsGrid retrievedPayouts={payouts} />
              )}
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default DashboardBodyMain;
